import React from "react";

function EvaluationItem(props){
    return(
        <div>
                <br/><img src={props.image} alt="" onContextMenu={(e)=> e.preventDefault()} /><br/>
                {props.dateName}<br/>
                {props.eval}<br/><br/>


        </div>

    );
}

export default EvaluationItem